<template>
	<div class="notification-wrapper">
		<div class="notification" v-if="hasNotification">
			<div class="notification-text">{{ nextNotification.message }}</div>
			<a
				class="notification-action"
				@click="viewNotification(nextNotification)"
				>OK</a
			>
		</div>
	</div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
	name: 'notification',
	props: ['value'],
	computed: {
		...mapGetters(['nextNotification', 'hasNotification'])
	},
	methods: {
		...mapActions(['getNotifications', 'viewNotification'])
	}
}
</script>

<style lang="scss">
.notification-wrapper {
	position: fixed;
	bottom: 15px;
	max-width: 480px;
	padding: 15px;
	z-index: 9999;
	.notification {
		background: #fff;
		box-shadow: 0 10px 24px rgba(0, 0, 0, 0.1);
		border-radius: 12px;
		width: 100%;
		padding: 20px;
		display: flex;
		.notification-action {
			background: rgba(0, 18, 48, 0.8);
			color: #fff;
			border-radius: 20px;
			padding: 8px 20px;
			font-weight: bold;
			cursor: pointer;
			&:hover {
				background: rgba(0, 18, 48, 0.9);
			}
		}
	}
}
</style>
